<!-- @file 隐私协议checkbox 组件 -->
<template>
  <div class="plv-ia-privacy-checkbox" :class="{'plv-ia-privacy-checkbox--disabled': disabled}">
    <input
      :id="inputId"
      :checked="checked"
      type="checkbox"
      @change="$emit('change', $event.target.checked)"
    />
    <label class="plv-ia-privacy-checkbox__style" :for="!disabled && inputId"></label>
    <label
      class="plv-ia-privacy-checkbox__content"
      :for="!disabled && inputId"
      v-html="content"
    ></label>
  </div>
</template>

<script>
export default {
  name: 'PrivacyCheckBox',
  model: {
    prop: 'checked',
    event: 'change'
  },

  props: {
    checked: {
      type: Boolean,
      default: false
    },

    content: {
      type: String,
      default: ''
    },

    inputId: {
      type: String,
      default: 'plv-checkbox-id'
    },

    disabled: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style>
.plv-ia-privacy-checkbox {
  display: inline-flex;
  align-items: top;
}

.plv-ia-privacy-checkbox--disabled {
  pointer-events: none;
}

.plv-ia-privacy-checkbox--disabled > input + label {
  border-color: #cfd8dc;
  background: #e9ecee;
  color: #9e9e9e;
}

.plv-ia-privacy-checkbox--disabled > label {
  color: #9e9e9e;
}

.plv-ia-privacy-checkbox > input {
  display: none;
}

.plv-ia-privacy-checkbox__content {
  display: inline-block;
  cursor: pointer;
  flex: 1;
  word-break: break-all;
}

.plv-ia-privacy-checkbox__content > p {
  display: inline;
  overflow: hidden;

  margin: 0;
  margin-top: 1px;

  text-overflow: ellipsis;
}

.plv-ia-privacy-checkbox__style {
  display: inline-block;
  width: 16px;
  height: 16px;
  border-radius: 3px;
  border: 1px solid #cfd8dc;
  position: relative;
  cursor: pointer;
  justify-items: center;
  margin-right: 5px;
}

.plv-ia-privacy-checkbox__style::before {
  display: inline-block;
  content: ' ';
  width: 8px;
  border: 2px solid #fff;
  height: 3px;
  border-top: none;
  border-right: none;
  transform: rotate(-45deg);
  top: 5px;
  left: 3px;
  position: absolute;
  opacity: 0;
}

.plv-ia-privacy-checkbox > input:checked + label {
  background: #2196f3;
}

.plv-ia-privacy-checkbox > input:checked + label::before {
  opacity: 1;
  transform: all 0.5s;
  background: #2196f3;
}
</style>
